<template>
  <v-container fluid class="dialer-container pa-0">
    <!-- Modern Header -->
    <div v-if="showHeader" class="header-section mb-4">
      <v-btn icon small class="header-close-btn" @click="dismissHeader">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <div class="d-flex align-center mb-4">
        <div class="header-icon-wrapper mr-4">
          <v-icon size="32" color="#FFFFFF">mdi-phone-settings</v-icon>
        </div>
        <div class="flex-grow-1">
          <h1 class="page-title mb-1">Default Dialer</h1>
          <p class="page-subtitle mb-0">
            Choose your preferred dialing application
          </p>
        </div>
        <v-spacer></v-spacer>
        <div class="d-none d-sm-flex">
          <v-chip
            class="mr-2 white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">mdi-phone</v-icon>
            Integrated
          </v-chip>
          <v-chip
            class="white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">mdi-cog</v-icon>
            Customizable
          </v-chip>
        </div>
      </div>

      <!-- Feature Pills -->
      <v-row class="feature-pills ma-0">
        <v-col cols="12" sm="6" md="4" lg="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2"
              >mdi-phone-classic</v-icon
            >
            <span>Native Dialer</span>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2">mdi-whatsapp</v-icon>
            <span>WhatsApp</span>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2">mdi-apps</v-icon>
            <span>Third Party Apps</span>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2">mdi-cog</v-icon>
            <span>Preferences</span>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row class="ma-0 px-3">
      <v-col cols="12" md="8" lg="6" class="mx-auto">
        <v-card class="modern-card customBorderRadius" elevation="0">
          <div class="card-header-green"></div>

          <v-card-title class="pb-2 pt-6">
            <div class="text-center w-100">
              <h3 class="text-h5 font-weight-medium mb-2">
                Select Dialer Application
              </h3>
              <p class="text-caption text--secondary mb-0">
                GoDial allows you to place calls via your phone's dialer or from
                any of the following apps
              </p>
            </div>
          </v-card-title>

          <v-card-text class="pa-6">
            <v-radio-group v-model="selectedDialer" class="dialer-radio-group">
              <v-list class="transparent pa-0">
                <template v-for="(item, index) in dialerLists">
                  <v-list-item
                    :key="index"
                    class="dialer-list-item mb-3"
                    @click="selectedDialer = item.name"
                  >
                    <v-list-item-avatar size="48" class="mr-4">
                      <v-img :src="item.logo" contain></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium text-body-1">
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-radio :value="item.name" color="primary"></v-radio>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="index < dialerLists.length - 1"
                    :key="'divider-' + index"
                  ></v-divider>
                </template>
              </v-list>
            </v-radio-group>

            <div class="text-center mt-6">
              <v-btn
                color="primary"
                depressed
                large
                block
                style="border-radius: 8px;"
                @click="setDefaultDialer"
              >
                <v-icon left>mdi-check-circle</v-icon>
                Set Default Dialer
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="loader" persistent width="300">
      <v-card color="primarygrad white--text" dark>
        <v-card-text style="padding: 18px 25px">
          <h3 style="margin-bottom: 5px; font-weight: 400; font-size: 16px">
            Please Wait...
          </h3>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      showHeader: false,
      loader: false,
      selectedDialer: "Phone Dialer",
      dialerLists: [
        {
          name: "Phone Dialer",
          logo: require("../assets/dialers/dialer.png"),
          package: "",
          ios: true,
          android: true,
          desktop: true,
        },
        {
          name: "FaceTime",
          logo: require("../assets/dialers/facetime.png"),
          package: "",
          ios: true,
          android: false,
          desktop: true,
        },

        {
          name: "Vonage",
          logo: require("../assets/dialers/vonage.png"),
          package: "com.vocalocity.Administration",
          ios: false,
          android: true,
          desktop: false,
        },
        {
          name: "Bria",
          logo: require("../assets/dialers/bria.png"),
          package: "com.counterpath.bria",
          ios: false,
          android: true,
          desktop: false,
        },
        {
          name: "Finera MobileVOIP",
          logo: require("../assets/dialers/finera.png"),
          package: "finarea.MobileVoip",
          ios: false,
          android: true,
          desktop: false,
        },
        {
          name: "Truecaller",
          logo: require("../assets/dialers/truecaller.png"),
          package: "",
          ios: false,
          android: true,
          desktop: false,
        },
        {
          name: "Skype",
          logo: require("../assets/dialers/skype.png"),
          package: "",
          ios: true,
          android: true,
          desktop: true,
        },
        {
          name: "Google Hangouts",
          logo: require("../assets/dialers/hangout.png"),
          package: "com.google.android.apps.hangoutsdialer",
          ios: false,
          android: true,
          desktop: false,
        },
        {
          name: "Magic Jack",
          logo: require("../assets/dialers/magicjack.png"),
          package: "com.magicjack",
          ios: false,
          android: true,
          desktop: false,
        },
        {
          name: "Zoiper",
          logo: require("../assets/dialers/zoiper.png"),
          package: "com.zoiper.android.app",
          ios: true,
          android: true,
          desktop: true,
        },
        {
          name: "Line",
          logo: require("../assets/dialers/line.png"),
          package: "jp.naver.line.android",
          ios: true,
          android: true,
          desktop: false,
        },
        {
          name: "Viber",
          logo: require("../assets/dialers/viber.png"),
          package: "com.viber.voip",
          ios: false,
          android: true,
          desktop: false,
        },
        {
          name: "2ndLine",
          logo: require("../assets/dialers/2ndline.png"),
          package: "com.enflick.android.tn2ndLine",
          ios: false,
          android: true,
          desktop: false,
        },
        {
          name: "Satellite",
          logo: require("../assets/dialers/satellite.png"),
          package: "de.sipgate.app.satellite",
          ios: false,
          android: true,
          desktop: false,
        },
        {
          name: "Knowlarity",
          logo: require("../assets/dialers/knowlarity.png"),
          package: "",
          ios: true,
          android: true,
          desktop: true,
        },
        {
          name: "Exotel",
          logo: require("../assets/dialers/Exotel.png"),
          package: "",
          ios: true,
          android: true,
          desktop: true,
        },
        {
          name: "Telecmi",
          logo: require("../assets/dialers/telecmi.png"),
          package: "",
          ios: true,
          android: true,
          desktop: true,
        },
      ],
    };
  },
  computed: {
    ...mapState(["ENDPOINT", "companyDetails"]),
  },
  async created() {
    this.showHeader =
      localStorage.getItem("defaultDialerHeaderDismissed") !== "true";
    try {
      await this.refresh();
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("defaultDialerHeaderDismissed", "true");
    },
    // Load this page
    async refresh() {
      try {
        var filter = {
          include: [{ relation: "plan", scope: { include: ["coupons"] } }],
        };
        var response = await this.$http.get(
          `${this.$store.state.ENDPOINT}/companies/${
            this.$store.getters.user.companyId
          }?filter=${encodeURIComponent(JSON.stringify(filter))}`,
        );
        response = response.body;
        console.log("response.body", response);
        this.$store.commit("setCompany", response); // store this company details
        this.selectedDialer = response.defaultDialer;
      } catch (e) {
        console.log("Error", e);
      }
    },
    async setDefaultDialer() {
      const self = this;
      console.log("this.selectedDialer", self.selectedDialer);

      console.log("companyDetails", self.companyDetails);

      self.loader = true;

      self.$http
        .patch(
          `${self.ENDPOINT}/companies/${self.$store.getters.user.companyId}`,
          {
            defaultDialer: self.selectedDialer,
          },
        )
        .then((response) => {
          self.loader = false;
          console.log("response", response.body);

          self.$swal({
            type: "success",
            text: "Default dialer set is successfully",
          });

          self.refresh();
        })
        .catch((err) => {
          console.log("err", err);
          self.loader = false;
          self.$swal({
            type: "error",
            text: "Something went wrong. Try again later",
          });
        });
    },
  },
};
</script>
<style scoped>
.dialer-container {
  background-color: var(--v-background-base, #f5f5f5);
  min-height: 100vh;
}

.theme--dark .dialer-container {
  background-color: #121212 !important;
}

.header-section {
  background: linear-gradient(135deg, #37cf37 0%, #2ba82b 100%);
  border-radius: 12px;
  padding: 32px;
  color: white;
  box-shadow: 0 4px 20px rgba(55, 207, 55, 0.3);
}

.header-icon-wrapper {
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.page-title {
  font-size: 32px;
  font-weight: 600;
  color: white;
  margin: 0;
  line-height: 1.2;
}

.page-subtitle {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.feature-pills {
  margin-top: 24px;
}

.feature-pill {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 12px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.feature-pill:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.modern-card {
  background: white;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.customBorderRadius {
  border-radius: 12px !important;
  overflow: hidden !important;
}

.card-header-green {
  height: 4px;
  background: linear-gradient(90deg, #37cf37 0%, #2ba82b 100%);
  border-radius: 12px 12px 0 0;
}

.w-100 {
  width: 100%;
}

.dialer-radio-group {
  margin-top: 0 !important;
}

.dialer-list-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px 16px !important;
  transition: all 0.2s;
  cursor: pointer;
}

.dialer-list-item:hover {
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

@media (max-width: 960px) {
  .header-icon-wrapper {
    width: 56px;
    height: 56px;
  }

  .page-title {
    font-size: 28px;
  }
}

/* Dark Theme Styles */
.theme--dark .modern-card {
  background: #1e1e1e !important;
  border-color: #404040 !important;
}

.theme--dark .modern-card .text-h5 {
  color: #e0e0e0 !important;
}

.theme--dark .modern-card .text-caption,
.theme--dark .modern-card .text--secondary {
  color: #a0a0a0 !important;
}

.theme--dark .dialer-list-item {
  background: #2d2d2d !important;
}

.theme--dark .dialer-list-item:hover {
  background: #353535 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.theme--dark .dialer-list-item .v-list-item__title {
  color: #e0e0e0 !important;
}

.theme--dark .v-divider {
  border-color: #404040 !important;
}

.theme--dark .header-section .page-title {
  color: white !important;
}

.theme--dark .header-section .page-subtitle {
  color: rgba(255, 255, 255, 0.9) !important;
}

.theme--dark .header-section .feature-pill {
  color: white !important;
}
</style>
